var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"eyeRef",staticClass:"eyeball",style:({
  width: _vm.size + 'px', height: _vm.isBlinking ? '2px' : _vm.size + 'px',
  backgroundColor: _vm.eyeColor,
})},[(!_vm.isBlinking)?_c('div',{staticClass:"pupil-inner",style:({
    width: _vm.pupilSize + 'px', height: _vm.pupilSize + 'px',
    backgroundColor: _vm.pupilColor,
    transform: `translate(${_vm.pos.x}px, ${_vm.pos.y}px)`,
  })}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }